import { ColumnsType } from "antd/es/table";
import AntTable from "../../components/table/Table";
import {
    EditOutlined,
    DeleteOutlined
} from "@ant-design/icons";
import {  Button, Flex, Image, Modal, Space, notification } from "antd";
import React, { useState } from "react";
import { CouponService } from "../../services/CouponService";
import moment from "moment";
import { useParams } from "react-router-dom";
import CreateCouponCode from "./CreateCouponCode";
import EditMember from "./../member/EditMember";
import UploadCouponCode from "./UploadCouponCode";

export default function CouponCode() {

    const { coupon_id } = useParams();

    const [isModalOpenUpload, setIsModalOpenUpload] = useState<boolean>(false);
    const [isModalOpenUser, setIsModalOpenUser] = useState<boolean>(false);
    const [editRecordUser, setEditRecordUser] = useState<object>()
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
    const [refreshData, setRefreshData] = useState<boolean>(false)

    const [columns] = useState<ColumnsType<any>>([
        {
            title: 'Id',
            align: 'center',
            dataIndex: 'id',
            key: 'id',
            render: (value, record) => {
                return value
            },
        },
        {
            title: 'Coupon',
            align: 'center',
            dataIndex: 'coupon',
            key: 'coupon',
            render: (value, record) => {
                return value.name;
            },
        },
        {
            title: 'Code',
            align: 'center',
            dataIndex: 'code',
            key: 'code',
            render: (value, record) => {
                return value;
            },
        },
        {
            title: 'Is Redeemed',
            align: 'center',
            dataIndex: 'is_redeem',
            key: 'is_redeem',
            render: (value, record) => {
                return value;
            },
        },

        {
            title: 'Redeemed At',
            align: 'center',
            dataIndex: 'redeemed_at',
            key: 'redeemed_at',
            render: (value, record) => {
                return moment(value).isValid() ? moment(value).format('DD-MM-YYYY HH:mm') : null;
            },
        },
        {
            title: 'Redeemed By',
            align: 'center',
            dataIndex: 'couponUsages',
            key: 'couponUsages',
            render: (value, record) => {
                return <div
                    style={{ textDecoration: 'underline', cursor: 'pointer' }}
                    onClick={() => {
                        setEditRecordUser({
                            id: value?.user_id,
                            full_name: value?.full_name
                        })
                        setIsModalOpenUser(true)
                    }}>{value?.user_id}</div>

            },
        },
        {
            title: '',
            align: 'center',
            dataIndex: 'created_at',
            key: 'created_at',
            render: (text, record: any) => {
                return (
                    <Flex gap="small" wrap="wrap">
                        {/* <div onClick={() => {
                            setIsModalOpen(true)
                            setEditRecord(record)
                        }} >
                            <Button type="primary" icon={<EditOutlined></EditOutlined>}></Button>
                        </div> */}
                        <div onClick={() => onDelete(record.id)} >
                            <Button type={'primary'} danger icon={<DeleteOutlined></DeleteOutlined>}></Button>
                        </div>
                    </Flex>
                )
            }
        },

    ])


    const onLoadData = async (params: any = {}) => {
        const payload = {
            ...params,
            coupon_id: coupon_id
        }
        const res = await CouponService.getCouponCodes(payload)
        return res
    }


    const onDelete = async (id: number) => {
        const res = await CouponService.deleteCouponCode(id)

        if (res.status == 1) {
            notification.open({
                type: 'success',
                message: res.status_detail,
                placement: 'top'
            });
            setRefreshData(p => !p)
        } else {
            notification.open({
                type: 'error',
                message: res.status_detail,
                placement: 'top'
            });
        }
    }


    return (
        <>


            <Modal
                title=""
                open={isModalOpen}
                onOk={() => setIsModalOpen(true)}
                onCancel={() => setIsModalOpen(false)}
                footer={null}>
                <CreateCouponCode
                    record={{
                        coupon: {
                            id: coupon_id
                        }
                    }}
                    onFinish={() => {
                        setIsModalOpen(false)
                        setRefreshData(p => !p)
                    }}
                ></CreateCouponCode>
            </Modal>
            <Modal
                title=""
                width={900}
                open={isModalOpenUser}
                onOk={() => setIsModalOpenUser(true)}
                onCancel={() => setIsModalOpenUser(false)}
                footer={null}>
                <EditMember
                    record={editRecordUser}
                    onFinish={() => {
                        setIsModalOpenUser(false)
                    }}
                ></EditMember>
            </Modal>

            <Modal
                title=""
                width={900}
                open={isModalOpenUpload}
                onOk={() => setIsModalOpenUpload(true)}
                onCancel={() => setIsModalOpenUpload(false)}
                footer={null}>
                <UploadCouponCode
                    record={{
                        coupon: {
                            id: coupon_id
                        }
                    }}
                    onFinish={() => {
                        setIsModalOpenUpload(false)
                        setRefreshData(p => !p)
                    }}
                ></UploadCouponCode>
            </Modal>
            <AntTable
                refresh={refreshData}
                menuOptions={[{
                    label: 'Create Coupon Code',
                    key: 'create'
                }, {
                    label: 'Upload Code',
                    key: 'upload'
                }]}
                menuClick={(e) => {
                    if (e.key == 'create') {
                        setIsModalOpen(true)
                    } else if (e.key == 'upload') {
                        setIsModalOpenUpload(true)
                    }

                }}
                search
                title="Coupon Code"
                columns={columns}
                onLoadData={onLoadData}
            />

        </>
    )
}
